import {useEffect, useState} from "react";
import CreatableSelect from 'react-select/creatable';
import parse from 'html-react-parser';
import Select from 'react-select';
import WINWorker from "../../Services/WINWorker";

export default function ProjectMember(props) {

    const [isEditing, setIsEditing] = useState(false);
    const [memberRole, setMemberRole] = useState('');
    const [member, setMember] = useState({});
    const [isNew, setIsNew] = useState(false);
    const [updateMember, setUpdateMember] = useState([])
    const [memberList, setMemberList] = useState([])

    let updateMemberSelectOptions = [];
    let projectMembers = props.members;
    const project = window.project_id;

    let initProjectMembers = () => {
        if (memberList.length === 0) {
            setMemberList(props.members);
        }
    }

    useEffect(
        () => {
            initProjectMembers();
        },
        [props]
    );

    const editProjectMember = (projectMember) => {
        setIsEditing(false);
        setUpdateMember([]);
        console.log('projectMemberEdit', projectMember);

        setIsNew(false);

        setMemberRole(projectMember.role);
        setMember(projectMember.name);

        setUpdateMember([
            {
                label: projectMember.name,
                value: projectMember.name,
                projectMember: projectMember
            }
        ]);

        setIsEditing(true);

    }


    const addProjectMember = () => {
        setIsEditing(true);
        setIsNew(true);
        setMemberRole('');
        setMember({});
    }

    const createOrUpdateProjectMember = () => {
        let createOrUpdateData = {};
        console.log('memberRole:', memberRole);
        console.log('member:', member);
        if (!isNew) {
            console.log('updateMembesssr', updateMember)
            createOrUpdateData = updateMember[0].projectMember;
            createOrUpdateData.role = memberRole;
            createOrUpdateData.materials = memberRole;
        } else {
            createOrUpdateData.member_id = member.value;
            createOrUpdateData.member_name = member.label;
            createOrUpdateData.role = memberRole;
            createOrUpdateData.materials = memberRole;
        }
        setIsEditing(false);
        setIsNew(false);
        WINWorker.createOrUpdateProjectMember(project, createOrUpdateData)
            .then(response => {
                console.log('response', response);
                setMemberList(response);
            })
            .catch(error => {
                console.log('error', error);
            });
    }


    let filterdProjectMembers = memberList.filter(member => member.member_involvement_type === props.member_involvement_type);

    const partnerOptions = window.partnerOptions;


    let preferred_partners = [];
    if (Object.hasOwn(partnerOptions, 'preferred_partners')) {
        preferred_partners = partnerOptions['preferred_partners']
            .filter(item => !filterdProjectMembers.map(x => x.name).includes(item.name))
            .map(item => {
                return {
                    value: item.id,
                    label: item.name
                }
            });
    }

    let non_preferred_partners = [];
    if (Object.hasOwn(partnerOptions, 'non_preferred_partners')) {
        non_preferred_partners = partnerOptions['non_preferred_partners']
            .filter(item => !filterdProjectMembers.map(x => x.name).includes(item.name))
            .map(item => {
                return {
                    value: item.id,
                    label: item.name
                }
            });
    }


    const groupedOptions = [
        {
            label: '',
            options: preferred_partners,
        },
        {
            label: '',
            options: non_preferred_partners,
        },
    ];

    return (
        <div className="form__row partner_associate_type">
            <label htmlFor="architects"
                   className="form__label form__label--highlight">{props.member_type_label}s</label>
            <div className="flex-between">
                <div className="flex__item flex__item-form-width">
                    {!isEditing &&
                        <a href="#" className="btn-item-add" onClick={(event) => {
                            event.preventDefault();
                            addProjectMember();
                        }}>
                            <span>Add {props.member_type_label}</span>
                            <span className="btn__icon">
                        <img src="/static/images/png/plus-icon.png" alt="Icon Plus" width="58" height="58"/>
                    </span>
                        </a>
                    }
                    {isEditing && (
                        <React.Fragment>
                            <div className="form__row">
                                <div className="form__group">
                                    <span className="form__sublabel">{parse(window.partner_options_entry)}</span>
                                </div>
                            </div>

                            <div className="form__row">
                                <div className="form__group">
                                    <label className="form__label" htmlFor="partner_id">Partner</label>
                                    <div className="form__group">
                                        <div className="select-default partner-select-option">
                                            {!isNew ?
                                                <Select
                                                    defaultValue={updateMember[0]}
                                                    isDisabled={!isNew} options={updateMember}/>
                                                :
                                                <CreatableSelect isClearable
                                                                 formatCreateLabel={userInput => `Manually add: ${userInput}`}
                                                                 placeholder={'Select from list or type the name'}
                                                                 isDisabled={!isNew} options={groupedOptions}
                                                                 onChange={(e) => setMember(e)}/>

                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="form__row">
                                <div className="form__group">
                                    <label className="form__label" htmlFor="name">Materials Provided:</label>
                                    <input type="text" name="materials" className="form-control form-control-name"
                                           placeholder="Materials Provided" id="project_partner_materials"
                                           value={memberRole} onChange={(e) => setMemberRole(e.target.value)}/>
                                </div>
                            </div>
                            <div className="form__row form__row--flex involvement-submit">
                                <input type="hidden" name="save_type" id="project-partner-save-type"
                                       className="project-partner-save-type"
                                       value="new"/>
                                <button id="save-project-partner" type="submit" value="GO"
                                        className="btn form__btnv save-project-partner" onClick={(event) => {
                                    event.preventDefault();
                                    createOrUpdateProjectMember();
                                }}>
                                    Done
                                </button>
                                <a href="#" className="link-icon cancel-project-partner" onClick={(event) => {
                                    event.preventDefault();
                                    setIsEditing(false);
                                }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="10.68" height="13.732"
                                         viewBox="0 0 10.68 13.732">
                                        <path
                                            d="M.763 12.206a1.53 1.53 0 0 0 1.526 1.526h6.1a1.53 1.53 0 0 0 1.526-1.526V3.051H.763zM2.64 6.774L3.715 5.7 5.34 7.317 6.957 5.7l1.076 1.076-1.617 1.617 1.617 1.617-1.076 1.076L5.34 9.467l-1.617 1.617-1.076-1.075 1.617-1.617zM8.01.763L7.247 0H3.433L2.67.763H0v1.526h10.68V.763z"
                                            fill="currentColor"></path>
                                    </svg>
                                    <span>Cancel</span>
                                </a>
                            </div>
                        </React.Fragment>
                    )}
                </div>
                <div className="flex__item project-associates-list">
                    {filterdProjectMembers.map((item, index) => (
                        <div key={index} className="block-bordered-item project-associates">
                            <div className="block__inner">
                                <div className="block__content">
                                    <div className="block__highlight">
                                    </div>
                                    <h5 className="block__title block__title--large">{item.name}</h5>
                                    <div className="block__entry">
                                        <span>{item.role}</span>
                                    </div>
                                </div>
                                <div className="block__actions">
                                    {!isEditing && (
                                        <React.Fragment>
                                            <a href="#" onClick={(event) => {
                                                event.preventDefault();
                                                editProjectMember(item);
                                            }} className="link-icon associate__cta"><span>Edit</span></a>
                                        </React.Fragment>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}
